export const EDIT_LEASE = 'app/LeaseDataTab/EDIT_LEASE';
export const EXECUTE_LEASE = 'app/LeaseDataTab/EXECUTE_LEASE';
export const UPLOAD_LEASE = 'app/LeaseDataTab/UPLOAD_LEASE';
export const SEND_TO_PORTAL = 'app/LeaseDataTab/SEND_TO_PORTAL';
export const GET_SIGNATURE_STATUSES = 'app/LeaseDataTab/GET_SIGNATURE_STATUSES';
export const GET_SIGNATURE_STATUSES_SUCCESS =
  'app/LeaseDataTab/GET_SIGNATURE_STATUSES_SUCCESS';
export const GET_SIGNATURE_STATUSES_ERROR =
  'app/LeaseDataTab/GET_SIGNATURE_STATUSES_ERROR';
